import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Article } from 'src/app/models/article';
import { Personne } from 'src/app/models/personne';

@Component({
  selector: 'achatarticlesmodal',
  templateUrl: './achatarticlesmodal.component.html',
  styleUrls: ['./achatarticlesmodal.component.css']
})
export class AchatarticlesModalComponent implements OnInit {
  @ViewChild('content') modal: TemplateRef<any>;

  private articleCourant: Article = new Article();
  private articlesAchetes: Article[] = [];
  private total: number=0;

  private clientCourant:Personne;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.appService.achatModal = this.modal;
  }

  initAchatArticles(client: Personne) {
    this.clientCourant=client;
  }

  rechercherArticle() {
    this.articleCourant = this.appService.articles.find(articleCourant => articleCourant.num === this.articleCourant.num);
    this.articleCourant.acheteur = this.clientCourant;
    this.articlesAchetes.push(this.articleCourant);
    this.total += parseFloat(this.articleCourant.prixVente);

    this.appService.articlesVendus.push(this.articleCourant);
    this.appService.articlesNonVendus.splice(this.appService.articlesNonVendus.findIndex(article=>article.num===this.articleCourant.num), 1);
    

    this.articleCourant = new Article();
  }

  encaisser() {
    
  }

}
